// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2837":"8c285278","6061":"d20617b3"}[chunkId] + ".css";
};